<template>
  <div class="page-auto">
    <div class="flex justify-s-b">
      <p class="auto-title">猜你想这么写<span class="subtitle" v-show="autoWriteList.length !== 0">（点击自动帮你写简历）</span></p>
      <div class="flex flex-c refresh" v-show="autoWriteTotal > 5">
        <i class="iconfont iconrotate-cw" :class="[replace? 'replace-active' : '']"></i>
        <span class="replace-btn" @click="handleClickRefresh">换一批</span>
      </div>
    </div>
    <div class="flex justify-s-b" v-show="autoWriteList.length === 0">
      <p class="guide-text">试试在经历描述中输入动词（例如：<span class="keyword">负责、进行、组织、完成......</span>）</p>
    </div>
    <div v-show="autoWriteTotal">
      <transition name="el-zoom-in-top">
        <div v-show="isAutoTransition">
          <div class="content-item" v-for="(item, index) in autoWriteList" :key="index" @click="handleClickContentItem(item.substr(2))">
            <span class="light">{{item.substr(0, 2)}}</span>{{item.substr(2)}}
          </div>
        </div>
      </transition>
    </div>
    <div class="loading-box" v-show="isAutoLoading">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  export default {
    name: "cv-auto-write",
    props:{
      keyWord:[String]
    },
    data(){
      return{
        replace: false,
        change: false
      }
    },
    computed:{
      ...mapState('editor',['autoWriteList', 'autoWriteTotal', 'currentInfo' ,'postId', 'isAutoLoading', 'isAutoTransition']),
    },
    methods:{
      ...mapActions('editor',['getAutoResumeWriteList']),
      ...mapMutations("editor",['setAutoWriteList', 'setAutoWriteTotal']),
      handleClickContentItem(item){
        this.$emit('on-select',{text: item})
      },
      handleClickRefresh(){
        this.replace = true
        setTimeout(()=>{
          this.replace = false
        }, 300)
        this.getAutoResumeWriteList({text: this.keyWord, profession_id: this.postId, job_title: this.currentInfo.data.title})
      }
    },
    watch:{
      keyWord(value){
        if(value && value.length > 0){
          this.getAutoResumeWriteList({text: value, profession_id: this.postId, job_title: this.currentInfo.data.title})
        } else {
          this.setAutoWriteList([])
          this.setAutoWriteTotal(0)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.page-auto{
  padding-top: 16px;
  position: relative;
  .auto-title{
    font-size: 14px;
    font-weight: 500;
    color: #404040;
    line-height: 20px;
    margin-bottom: 14px;
    .subtitle{
      font-size: 12px;
      font-weight: 500;
      color: #9C9C9C;
      line-height: 20px;
    }
  }
  .guide-text{
    font-size: 14px;
    font-weight: 400;
    color: #404040;
    line-height: 14px;
    .keyword{
      color: #FF6644;
    }
  }
  .replace-btn{
    font-size: 14px;
    color: #404040;
    font-weight: 400;
    margin-left: 9px;
  }
  .refresh{
    cursor: pointer;
  }
  .content-item{
    padding: 16px 24px;
    background: #F9F9F9;
    border-radius: 2px 16px 16px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #404040;
    line-height: 22px;
    margin-bottom: 8px;
    cursor: pointer;
    .light{
      color: #FF6644;
    }
  }
  .replace-active{
    animation: replaceAni linear 0.3s;
  }
  @keyframes replaceAni {
    from{
      transform: rotate(0deg);
    }to{
       transform: rotate(360deg);
     }
  }
  .loading-box{
    width: 100%;
    height: 200px;
    background: rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-top: 20px;
    position: absolute;
    top: 60px;
  }
}

</style>